import { ElementAttributes } from '@ratehub/base-ui';

/**
 * Closes the header search popup
 */
export default function closeSearchPopup() {
    const searchPopup = document.querySelector(`#${ElementAttributes.HEADER_SEARCH_POPUP_ID}`);

    if (searchPopup && searchPopup.classList.contains('isOpen')) {
        searchPopup.classList.remove('isOpen');
    }
}
